import { render, staticRenderFns } from "./Requests.vue?vue&type=template&id=57d0d9fb"
import script from "./Requests.vue?vue&type=script&lang=ts"
export * from "./Requests.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports